import { render } from "./payments.vue?vue&type=template&id=3154196a&ts=true"
import script from "./payments.vue?vue&type=script&lang=ts"
export * from "./payments.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__